<div class="search-wrapper">
  <div class="search-form">
    <input
      type="text"
      class="contact-search"
      i18n-placeholder="@@survey.contactinfo.search.searchplaceholder"
      placeholder="Add existing contact"
      [formControl]="searchInput"
      (focus)="isFocus(true)"
    />
    <!-- (blur)="isFocus(false)" -->
    <mat-icon>search</mat-icon>
  </div>
  <div [matMenuTriggerFor]="menu" #menuTrigger="matMenuTrigger"></div>
  <mat-menu #menu="matMenu" class="search-dropdown">
    <ul class="search-results">
      <li
        class="search-result"
        *ngFor="let searchResult of searchResults"
        (click)="onSelectResult(searchResult)"
      >
        <span>{{ searchResult.name }}&nbsp;-&nbsp;</span
        ><strong>{{ searchResult.personType }}</strong>
      </li>
      <li class="search-result" (click)="onAddNewContact()">
        <div class="new-contact-icon">
          <mat-icon>add</mat-icon>
        </div>
        <span
          class="create-new-txt"
          i18n="@@survey.contactinfo.search.createnewcontact"
          >Create new contact</span
        >
      </li>
    </ul>
  </mat-menu>
</div>
